export enum EnumDato {
  NumeroDeDias = 1,
  NumeroDeMeses = 2,
  QdAplicadaDistribucion = 3,
  ConsumoDiario = 4,
  ConsumoPeriodo = 5,
  QdAplicadaRegasificacion = 6,
  QdCisternas = 7,
  ConsumoPeriodoDistribucion = 8,
  ConsumoPeriodoTransporte = 9,
  OpCompraVenta = 10,
  ConsumoPeriodoATR = 11,
  Potencia = 12,
  CAE = 13,
  OpCompraVentaPeriodo = 14,
  ConsumoRepartos = 15,
  QdContratada = 16,
  Existencias = 17,
  DesbalancePositivo = 18,
  DesbalanceNegativo = 19,
  NumeroViajes = 20,
  ConsumoRepartosInyeccion = 21,
  ConsumoRepartosExtraccion = 22,
  ConsumoCisternas = 23,
  QdContrato = 24,
  NumeroCisternas = 25,
  TransporteMaritimo = 26,
  TransporteTerrestre = 27,
  GastosAduana = 28,
  EntregaPuertoViaje = 29,
  RecogidaPuertoViaje = 30,
  Grua = 31,
  AparcamientoOperativo = 32,
  Paralizaciones = 33,
  Viaje = 34,
  Peaje = 35,
  SegundaSucesivasDescargas = 36,
  GeneracionHoraria = 37,
  GeneracionPeriodoATR = 38,
  ReactivaInductiva = 39,
  QdDemandada = 40,
  ConsumoLibre = 41,
  DesvioPositivo = 42,
  DesvioNegativo = 43,
  DesvioVA = 44,
  ConsumoBrutoDiario = 45,
  AccionBalance = 46,
  OpCompraVentaNeto = 47,
  DesvioBrutoNeto = 48,
  DesbalancePositivoPrevision = 49,
  DesbalanceNegativoPrevision = 50,
  LucroCesante = 51,
  ConsumoBrutoOnDemand = 52,
  NominacionBrutaOnDemand = 53,
  NominacionMDBrutaOnDemand = 54,
  NominacionIDA1BrutaOnDemand = 55,
  NominacionIDA2BrutaOnDemand = 56,
  NominacionIDA3BrutaOnDemand = 57,
  NominacionMC2BrutaOnDemand = 58,
  NominacionMC3BrutaOnDemand = 59,
  DesvioBrutoOnDemand = 60,
  DesvioBrutoVAOnDemand = 61,
  DesvioBrutoPositivoOnDemand = 62,
  DesvioBrutoNegativoOnDemand = 63
}
